
import { ClientCustomersView } from '@/components/client-management/ClientCustomersView';

const Clientes = () => {
  return <ClientCustomersView />;
};

export default Clientes;
